import { READING_MODE_PAGE, READING_MODE_PATH } from '@townsquare/config/routes';
import { createGlobalRoute } from '@townsquare/router/create-route';

export const readingModeRoute = createGlobalRoute({
  exact: true,
  name: READING_MODE_PAGE,
  path: READING_MODE_PATH,
});
